import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { changePassword } from '../actions'
import { lang } from '../strings'
import { trackEvent, CHANGE_PASSWORD, LOAD } from '../utils/analytics'

class ChangePassword extends Component {
  constructor(props) {
    super(props)
    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    return {
      validationError: null,
      successMessage: null,
    }
  }

  componentDidMount() {
    trackEvent(CHANGE_PASSWORD, LOAD)
  }

  render() {
    let { appState } = this.props
    let { validationError, successMessage } = this.state
    let { networkFailed } = appState.toJS()

    return (
      <div className='grid-x grid-margin-x grid-margin-y'>
        <div className='small-12 large-5 cell'>
          <div className='grid-y'>
            <h2>{lang.changePassword.title}</h2>
            <p>{lang.changePassword.intro}</p>
            {networkFailed && (
              <p className='mp-error-text'>
                {lang.changePassword.networkError}
              </p>
            )}
            {validationError && (
              <p className='mp-error-text'>{validationError}</p>
            )}
            {successMessage ? (
              <p className='mp-success-text'>{successMessage}</p>
            ) : (
              this.renderForm()
            )}
          </div>
        </div>
      </div>
    )
  }

  renderForm() {
    let { appState } = this.props
    let { networkProgress } = appState.toJS()

    let formClass = 'c-reset-password sqs-block-form'
    let buttonText = lang.changePassword.button

    if (networkProgress) {
      formClass += ' mp-disabled'
      buttonText = lang.changePassword.loading
    }

    return (
      <form onSubmit={this.changePassword} className={formClass}>
        <div className='form-item'>
          <label htmlFor='oldPassword'>{lang.changePassword.oldPassword}</label>
          <input type='password' name='oldPassword' />
          <label htmlFor='newPassword'>{lang.changePassword.newPassword}</label>
          <input type='password' name='newPassword' />
          <label htmlFor='confirmNewPassword'>
            {lang.changePassword.confirmPassword}
          </label>
          <input type='password' name='confirmNewPassword' />
        </div>
        <input
          type='submit'
          className='sqs-editable-button'
          value={buttonText}
        />
      </form>
    )
  }

  changePassword = ev => {
    ev.preventDefault()
    let form = ev.target
    let oldPassword = form.oldPassword.value
    let newPassword = form.newPassword.value
    let confirmNewPassword = form.confirmNewPassword.value
    let validationError = null

    if (oldPassword.length === 0) {
      validationError = lang.changePassword.oldPasswordError
    } else if (newPassword.length === 0) {
      validationError = lang.changePassword.newPasswordError
    } else if (confirmNewPassword.length === 0) {
      validationError = lang.changePassword.confirmPasswordError
    } else if (newPassword != confirmNewPassword) {
      validationError = lang.changePassword.mismatchError
    }
    this.setState({ validationError: validationError })

    if (!validationError) {
      this.props.dispatch(
        changePassword(oldPassword, newPassword, this.onSuccess)
      )
    }
  }

  onSuccess = () => {
    this.setState({ successMessage: lang.changePassword.successMessage })
  }
}

ChangePassword.propTypes = {
  dispatch: PropTypes.func.isRequired,
  appState: PropTypes.object.isRequired,
}

function propProvider(reduxState, props) {
  const { appState } = reduxState

  return {
    appState,
  }
}

export default connect(propProvider)(ChangePassword)
